var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"items":_vm.items,"item-text":_vm.itemText,"item-value":_vm.itemValue,"label":_vm.label,"chips":true,"multiple":""},model:{value:(_vm.internalModel),callback:function ($$v) {_vm.internalModel=$$v},expression:"internalModel"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c2e891e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/VChipsCombobox.vue
// module id = wTnL
// module chunks = 0